const permissionLevel = {
  none: 0,
  view: 1,
  readonly: 2,
  operator: 3,
  admin: 4,
}

class PermissionUtil {
  // readonly以上の権限かどうかを判定
  static isMoreReadonly(permission) {
    // inheritだったら問答無用でfalse
    if (permission === 'inherit') return false
    if (permissionLevel[permission] < permissionLevel['readonly']) return false
    return true
  }

  // readonlより上の権限かどうかを判定
  static isHigherReadonly(permission) {
    // inheritだったら問答無用でfalse
    if (permission === 'inherit') return false
    if (permissionLevel[permission] <= permissionLevel['readonly']) return false
    return true
  }
}

export default PermissionUtil
